module.exports = __WEBPACK_EXTERNAL_MODULE_13__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"experiment-mathjs","commonjs2":"experiment-mathjs","amd":"experiment-mathjs","root":"math"}
// module id = 13
// module chunks = 0